module.exports = __webpack_public_path__ + "img/save.e004fb59.svg";